import { useState, useEffect } from "react";
import { generateTicketTimeCardReport, fetchAllResources } from "../Api/TicketTimeCardReport";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import Dashboard from "../Components/Dashboard";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";
import { useAuth } from "../Context/AuthContext";
const TicketTimeCardReport = () => {
  const [loading, setLoading] = useState(false);
  const [fetchingResources, setFetchingResources] = useState(false);
  const [resources, setResources] = useState([]);
  const [reportData, setReportData] = useState({
    ResourceCode: "",
    FromDate: "",
    ToDate: "",
  });
  const [reportResults, setReportResults] = useState({
    data: [],
    message: "",
    count: 0,
    resourceId: "",
    fromDate: "",
    toDate: ""
  });
  const{user}=useAuth();
  const [showResults, setShowResults] = useState(false);
  const [errors, setErrors] = useState({});

  // Fetch resources on component mount
  useEffect(() => {
    const loadResources = async () => {
      setFetchingResources(true);
      // return
      try {
        const resources = await fetchAllResources(user?.organisationId);
        setResources(resources);
      } catch (error) {
        toast.error(`🦄 ${error.message || "Error loading resources"}`);
      } finally {
        setFetchingResources(false);
      }
    };
    loadResources();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReportData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when field is changed
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
    
    // If FromDate is cleared, also clear ToDate
    if (name === "FromDate" && !value) {
      setReportData(prev => ({ ...prev, ToDate: "" }));
      setErrors(prev => ({ ...prev, ToDate: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    // ResourceCode is always required
    if (!reportData.ResourceCode) {
      newErrors.ResourceCode = "Resource Code is required";
    }
    
    // If FromDate is entered, ToDate is required
    if (reportData.FromDate && !reportData.ToDate) {
      newErrors.ToDate = "To Date is required when From Date is entered";
    }
    
    // If both dates are entered, validate date range
    if (reportData.FromDate && reportData.ToDate) {
      if (new Date(reportData.ToDate) < new Date(reportData.FromDate)) {
        newErrors.ToDate = "To Date must be after From Date";
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    try {
      const response = await generateTicketTimeCardReport(reportData);
      setReportResults(response);
      setShowResults(true);
      toast.success(`🦄 ${response.message || "Report Generated Successfully"}`);
    } catch (error) {
      toast.error(`🦄 ${error.message || "Error Generating Report"}`);
      setShowResults(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* <Dashboard> */}
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Ticket Time Card Report</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Resource Code</Form.Label>
                    <Form.Select
                      name="ResourceCode"
                      value={reportData.ResourceCode}
                      onChange={handleChange}
                      required
                      disabled={fetchingResources}
                      isInvalid={!!errors.ResourceCode}
                    >
                      <option value="">Select Resource</option>
                      {resources.map((resource) => (
                        <option key={resource.value} value={resource.value}>
                          {resource.label}
                        </option>
                      ))}
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      {errors.ResourceCode}
                    </Form.Control.Feedback>
                    {fetchingResources && (
                      <small className="text-muted">Loading resources...</small>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>From Date (Optional)</Form.Label>
                    <Form.Control
                      type="date"
                      name="FromDate"
                      value={reportData.FromDate}
                      onChange={handleChange}
                      isInvalid={!!errors.FromDate}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.FromDate}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>To Date {reportData.FromDate && "(Required)"}</Form.Label>
                    <Form.Control
                      type="date"
                      name="ToDate"
                      value={reportData.ToDate}
                      onChange={handleChange}
                      disabled={!reportData.FromDate}
                      required={!!reportData.FromDate}
                      isInvalid={!!errors.ToDate}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.ToDate}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button 
                  variant="primary" 
                  type="submit" 
                  className="fields-submit" 
                  disabled={loading || fetchingResources}
                >
                  {loading ? "Generating..." : "Generate Report"}
                </Button>
              </div>
            </Form>

            {showResults && (
              <div className="mt-4">
                <h4>Report Results</h4>
                <div className="mb-3">
                  <p><strong>Message:</strong> {reportResults.message}</p>
                  <p><strong>Total Records:</strong> {reportResults.count}</p>
                  <p><strong>Resource ID:</strong> {reportResults.resourceId}</p>
                  <p><strong>Date Range:</strong> {new Date(reportResults.fromDate).toLocaleDateString()} to {new Date(reportResults.toDate).toLocaleDateString()}</p>
                </div>
                <div className="table-wrapper">
                  <div className="table-scroll-container">
                    {reportResults.data.length > 0 ? (
                      <Table striped bordered hover responsive className="data-table">
                        <thead>
                          <tr>
                            <th>Ticket Id</th>
                            <th>Resource ID</th>
                            <th>User Name</th>
                            <th>Date</th>
                            <th>Project Code</th>
                            <th>Hours</th>
                            <th>Task</th>
                            <th>Remarks</th>
                            <th>Location</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportResults.data.map((item, index) => (
                            <tr key={index}>
                              <td>{item.TicketId}</td>
                              <td>{item.ResourceId}</td>
                              <td>{item.UserName}</td>
                              <td>{item.Date}</td>
                              <td>{item.ProjectCode}</td>
                              <td>{item.Hours}</td>
                              <td>{item.Task}</td>
                              <td>{item.Remarks}</td>
                              <td>{item.Location}</td>         
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <div className="text-center py-4">
                        <p>No records found for the given criteria</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </Container>
        </div>
      {/* </Dashboard> */}

      {/* Loader Overlay with Sample 14 */}
      {(loading || fetchingResources) && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default TicketTimeCardReport;